module.exports = __webpack_public_path__ + "static/img/tt-6.4959b1a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/tt-6.jpg
 ** module id = 593
 ** module chunks = 2
 **/